import { render, staticRenderFns } from "./AddonEdit.vue?vue&type=template&id=b080440e&scoped=true&"
import script from "./AddonEdit.vue?vue&type=script&lang=js&"
export * from "./AddonEdit.vue?vue&type=script&lang=js&"
import style0 from "./AddonEdit.vue?vue&type=style&index=0&id=b080440e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b080440e",
  null
  
)

export default component.exports